import React, { useContext } from "react";
import { AuthContext } from '../../../../../auth-context'
import styled from "styled-components";
import _ from 'lodash'
import { assignTrainer, removeTrainer } from '../../../../../api'
import Popover from "@material-ui/core/Popover";
import Checkbox from "@material-ui/core/Checkbox";
import { withStyles } from "@material-ui/core/styles";

const WhiteCheckbox = withStyles({
  root: {
    color: "#FFF",
    "&$checked": {
      color: "#FFF",
    },
  },
  checked: {},
})((props) => <Checkbox {...props} />);

const CustomPopover = withStyles({
  paper: {
    background: "#060c29",
    borderRadius: "12px",
  },
})(Popover);

const Item = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  p {
    color: #fff;
    white-space: nowrap;
    padding: 0px 0px 0px 18px;
  }
`;

const Content = styled.div`
  color: #fff;
  padding: 6px;
  max-height: 360px;
`;

const Button = styled.button`
  border: none;
  background: none;
  width: 100%;
  flex-basis: content;

  svg {
    color: #FFF;
  }
`;

const ListItem = ({ name, checked, onChange }) => {
  return (
    <Item>
      <p>{name}</p>
      <WhiteCheckbox
        checked={checked}
        onChange={onChange}
        inputProps={{ "aria-label": "checkbox" }}
      />
    </Item>
  );
};

export const TrainerButton = ({button, accountID, assignedTrainers}) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const { user, updateUser } = useContext(AuthContext);
  const open = Boolean(anchorEl);

  const handleChange = (isAssigned, trainerID) => {
    if (isAssigned) {
      removeTrainer(user.id, accountID, trainerID)
        .then(function (response) {
          let newUser = _.cloneDeep(user);
          const newAssignedTrainers = _.without([...assignedTrainers], trainerID);
          const trainerIndex = newUser.team.findIndex(u => u.id === trainerID);
          const accountIndex = newUser.accounts.findIndex(u => u.id === accountID);
          newUser.team[trainerIndex].client_count = newUser.team[trainerIndex].client_count - 1;
          newUser.accounts[accountIndex].trainers = newAssignedTrainers
          updateUser(newUser)     
        })
        .catch(function (error) {
          // handle error
          console.log(error);
        })
    } else {
      assignTrainer(user.id, accountID, trainerID)
        .then(function (response) {
          let newUser = _.cloneDeep(user);
          const newAssignedTrainers = [...assignedTrainers]
          const trainerIndex = newUser.team.findIndex(u => u.id === trainerID);
          const accountIndex = newUser.accounts.findIndex(u => u.id === accountID);
          newAssignedTrainers.push(trainerID)
          newUser.team[trainerIndex].client_count = newUser.team[trainerIndex].client_count + 1;
          newUser.accounts[accountIndex].trainers = newAssignedTrainers
          updateUser(newUser)   
        })
        .catch(function (error) {
          // handle error
          console.log(error);
        })
    }
  }

  return (
    <>
      <Button onClick={(e) => setAnchorEl(e.currentTarget)}>
        {button}
      </Button>
      <CustomPopover
        id={accountID}
        open={open}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl("")}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
      >
        <Content>
          {user.team.length !== 0 ?
            user.team.map((trainer, index) => 
              <ListItem
                key={trainer.id}
                name={trainer.name}
                checked={assignedTrainers ? assignedTrainers.includes(trainer.id) : false}
                onChange={() => handleChange(assignedTrainers.includes(trainer.id), trainer.id)}
              />
            )
          :
            <p>No trainers have been added.</p>
          }
        </Content>
      </CustomPopover>
    </>
  );
};
